import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-customlib-checking',
  template: `
    <p>
      customlib-checking works!
    </p>
  `,
  styles: []
})
export class CustomlibCheckingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  testmethod1(){
    alert("checkinggs");
  }
}
